/*
Version 0.002

Made by: Finally // Aleks Schakel // www.finally.nl // aleks@finally.nl
Copyright 2016 - 2026.

!Changelog

2026
	12-04-2026
	- [BORN] This class is born. Hooray!
	- [ADDED] Added subtle glitch trigger for .brand.
	- [ADDED] Added random interval between glitch moments.

!Usage
	specific_glitch.onready();

*/

var specific_glitch = {};

(function () {

	/**
	 * Settings
	 */
	this.glitch_selector = '.brand';
	this.glitch_class = 'is-glitching';
	this.glitch_timeout = null;
	this.glitch_loop_timeout = null;

	/**
	 * On ready
	 */
	this.onready = function () {

		var _this = this;
		var $brand = $(this.glitch_selector);

		if ($brand.length == 0) {
			return;
		}

		this.start_loop();

		$(window)
			.off('blur.specific_glitch')
			.on(
				'blur.specific_glitch',
				function () {
					_this.stop_loop();
				}
			);

		$(window)
			.off('focus.specific_glitch')
			.on(
				'focus.specific_glitch',
				function () {
					_this.start_loop();
				}
			);

	};

	/**
	 * Start glitch loop
	 */
	this.start_loop = function () {

		var _this = this;

		this.stop_loop();

		this.glitch_loop_timeout = window.setTimeout(
			function () {

				_this.trigger_glitch();
				_this.start_loop();

			},
			this.get_random_delay()
		);

	};

	/**
	 * Stop glitch loop
	 */
	this.stop_loop = function () {

		if (this.glitch_timeout) {
			window.clearTimeout(this.glitch_timeout);
			this.glitch_timeout = null;
		}

		if (this.glitch_loop_timeout) {
			window.clearTimeout(this.glitch_loop_timeout);
			this.glitch_loop_timeout = null;
		}

		$(this.glitch_selector).removeClass(this.glitch_class);

	};

	/**
	 * Trigger glitch
	 */
	this.trigger_glitch = function () {

		var _this = this;
		var $brand = $(this.glitch_selector);

		if ($brand.length == 0) {
			return;
		}

		$brand.addClass(this.glitch_class);

		this.glitch_timeout = window.setTimeout(
			function () {
				$brand.removeClass(_this.glitch_class);
			},
			this.get_random_glitch_duration()
		);

	};

	/**
	 * Get random delay between glitches
	 */
	this.get_random_delay = function () {

		return Math.floor(
			2000 + Math.random() * 3200
		);

	};

	/**
	 * Get random glitch duration
	 */
	this.get_random_glitch_duration = function () {

		return Math.floor(
			100 + Math.random() * 120
		);

	};

}).apply(specific_glitch);